import type { LangEnum } from '@models/enums';

import type { ConsentItemTextsModel } from './consent-item-model';
import type {
    ConsentDisplayModeEnum,
    ConsentPolicyUrlsModel,
    ConsentSettingsCheckboxModel,
} from './consent-settings-model';

export enum ConsentShownInEnum {
    KYC_WIDGET = 'kyc_widget',
    KYB_WIDGET = 'kyb_widget',
}

export type ConsentWidgetItemModel = {
    item_id: string;
    version: number;
    checkboxes: ConsentSettingsCheckboxModel[];
    texts: ConsentItemTextsModel;
};

export type GetConsentResponse = {
    consent_given: boolean;
    display_mode: ConsentDisplayModeEnum;
    locales: LangEnum[];
    items: ConsentWidgetItemModel[];
    policy_urls?: Partial<ConsentPolicyUrlsModel>;
};

export type SignConsentCheckboxModel = {
    key: string;
    text: string;
    checked: boolean;
    checked_at?: string;
};

export type SignConsentItemModel = {
    item_id: string;
    version: number;
    locale: LangEnum;
    long: string;
    short: string;
    checkboxes: SignConsentCheckboxModel[];
};

export type SignConsentRequest = {
    shown_in: ConsentShownInEnum;
    locale: LangEnum;
    items: SignConsentItemModel[];
};

export type SignConsentResponse = {
    accepted_at: string;
};
